import React from "react";

export const ProCard = ({ icon: Icon, title, subtitle, badge, action, children, testid, className = "", onOpen }) => (
    <div data-testid={testid} className={`pd-card flex flex-col rounded-2xl p-5 ${className}`}>
        <div
            role={onOpen ? "button" : undefined}
            tabIndex={onOpen ? 0 : undefined}
            data-testid={onOpen ? `${testid}-open` : undefined}
            onClick={onOpen}
            onKeyDown={onOpen ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onOpen(); } } : undefined}
            className={`flex items-start gap-3 ${onOpen ? "cursor-pointer group rounded-xl -m-1 p-1 outline-none focus-visible:ring-2 focus-visible:ring-[var(--pd-accent-border)]" : ""}`}
        >
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[var(--pd-icon-bg)] text-[var(--pd-icon)] transition-colors group-hover:bg-[var(--pd-icon)] group-hover:text-[var(--pd-surface)]">
                <Icon size={20} />
            </span>
            <div className="min-w-0 flex-1">
                <div className="flex items-start justify-between gap-2">
                    <h3 className="text-base font-semibold leading-tight text-[var(--pd-text)] group-hover:text-[var(--pd-accent)] transition-colors">{title}</h3>
                    {badge}
                </div>
                {subtitle && <p className="mt-1 text-xs leading-relaxed text-[var(--pd-muted)]">{subtitle}</p>}
            </div>
        </div>
        {children && <div className="mt-4 flex-1">{children}</div>}
        {action && <div className="mt-4">{action}</div>}
    </div>
);

export const ProStat = ({ label, value, testid }) => (
    <div data-testid={testid} className="rounded-xl bg-[var(--pd-surface-2)] px-3 py-2.5 text-center">
        <div className="text-lg font-bold text-[var(--pd-icon)]">{value}</div>
        <div className="mt-0.5 text-[10px] uppercase tracking-wide text-[var(--pd-muted)]">{label}</div>
    </div>
);

export const ProTag = ({ children, tone = "slate", testid }) => (
    <span
        data-testid={testid}
        style={{ background: `var(--pd-tag-${tone}-bg)`, color: `var(--pd-tag-${tone})` }}
        className="shrink-0 rounded-full px-2.5 py-1 text-[10px] font-semibold"
    >
        {children}
    </span>
);

export const ProAction = ({ children, onClick, testid, variant = "solid", disabled, type = "button" }) => (
    <button
        type={type}
        data-testid={testid}
        onClick={onClick}
        disabled={disabled}
        className={
            variant === "solid"
                ? "w-full rounded-xl bg-blue-600 px-4 py-2.5 text-xs font-semibold text-white hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
                : "w-full rounded-xl border border-[var(--pd-border)] px-4 py-2.5 text-xs font-semibold text-[var(--pd-icon)] hover:border-[var(--pd-accent)] hover:text-[var(--pd-accent)] transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
        }
    >
        {children}
    </button>
);

export const ProEmpty = ({ children, testid }) => (
    <div data-testid={testid} className="rounded-xl border border-dashed border-[var(--pd-border)] px-3 py-5 text-center text-xs text-[var(--pd-muted)]">
        {children}
    </div>
);

export const timeAgo = (iso) => {
    if (!iso) return "";
    const mins = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));
    if (mins < 1) return "adesso";
    if (mins < 60) return `${mins} minuti fa`;
    const h = Math.floor(mins / 60);
    if (h < 24) return `${h} or${h === 1 ? "a" : "e"} fa`;
    const d = Math.floor(h / 24);
    return `${d} giorn${d === 1 ? "o" : "i"} fa`;
};
